<a id="closeEvent" class="d-none" (click)="CloseGallery()"><i class="fas fa-chevron-left"></i> Voltar</a>

<ng-container *ngIf="model != null">
  <div class="media_header" [@loadedFadeAnimation]="'visible'">
    <div class="media_header_photo">
      <img [src]="model.ImageFile.FileUri" class="img-fluid" alt="{{model.Title}}">
    </div>
    <div class="media_header_text">
      <h3 class="txt_bar">{{model.Title}}</h3>
      <div *ngIf="model.Content != null">
        Localização: <strong>{{model.Content}}</strong>
      </div>
      <div *ngIf="model.ShowEventDate">
        Data: <strong>{{model.EventDate | date: 'dd/MM/yyyy'}}</strong>
      </div>
      <div *ngIf="model.Url != null && model.Url != ''">
        Sítio Web: <a (click)="goToUrl()" class="pointer plain-link"><strong>Visitar</strong></a>
      </div>
    </div>
  </div>

  <ng-container *ngIf="(pollFilled == true || pollFilled == null) && galleries != null && galleries.length > 0">
    <h5 class="mt-4" [@loadedFadeAnimation]="'visible'">Galeria do evento</h5>

    <app-gallery [galleries]="galleries"></app-gallery>
  </ng-container>

  <ng-container *ngIf="pollFilled == false && loadedPoll">
    <div [@loadedFadeAnimation]="'visible'">
      <h5 class="mt-5">Pesquisa de satisfação</h5>
      <div class="mt-0 pb-3">Pode nos ajudar a melhorar preenchendo a pesquisa antes de acessar ao material do evento?</div>
      <div class="Campaing__form col-lg-10 col-xl-8 col-xxl-6">
        <form id="formulario" name="myForm" #frm (ngSubmit)="saveFormulario()">
          <div class="Campaing__form pl-2">
            <div [innerHtml]="this.HTML_FORM" class="external-html" runScripts></div>
          </div>
          <div class="card-footer my-3">
            <button type="submit" class="btn-orange"> Enviar</button>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</ng-container>